<h1>{{ 'cartDetails.cartName' | cxTranslate }}</h1>
<div class="eb-quick-order__content">
  <eb-quick-order-form></eb-quick-order-form>
  <div class="eb-quick-order__file-drop">
    <label class="eb-quick-order__csv-title">{{ 'csv.title' | cxTranslate }}</label>
    <ngx-file-drop
      (onFileDrop)="onFileDropChange($event)"
      [attr.error]=""
      [accept]="'.csv'"
      [showBrowseBtn]="true"
      [multiple]="false"
      [dropZoneLabel]="'csv.dropZoneLabel' | cxTranslate"
      [directory]="false"
      browseBtnClassName="eb-quick-order__browse-button"
      dropZoneClassName="eb-quick-order__file-drop-zone"
      contentClassName="eb-quick-order__file-drop-content"
    >
    </ngx-file-drop>
    <a (click)="downloadTemplate()" class="eb-quick-order__download-csv-template-link">
      {{ 'csv.templateDownload' | cxTranslate }}</a
    >
  </div>
</div>
<ng-template #modal>
  <eb-modal
    class="csv-upload__waiting-modal"
    [title]="'csv.waiting.title' | cxTranslate"
    [loaded$]="loaded$"
    [withoutClose]="true"
  >
    <p slot="description">
      {{ 'csv.waiting.description' | cxTranslate }}
    </p>

    <div slot="content">
      <eb-spinner alignment="center" width="100%"></eb-spinner>
    </div>
  </eb-modal>
</ng-template>
